import { CSSProperties } from "react";
import { UNKNOWN_VALUE } from "../../constants/display";
import { SPACING } from "../../constants/design/spacing";
import FillBar from "./FillBar";
import { FillMeterWrapper, FillPercentage } from "./style";

interface IFillMeter {
  // Number between 0 - 100
  fill: string;
  barColor?: string;
  textColor?: string;
  layoutReversed?: boolean;
  decimals?: number;
  barStyle?: CSSProperties;
  showText?: boolean;
}

function FillMeter({
  fill,
  barColor,
  textColor,
  layoutReversed,
  decimals,
  barStyle,
  showText = true,
}: IFillMeter) {
  const percentage = Number(fill);
  // `fill` arrives as a string straight from an API payload, so it can be
  // absent or non-numeric — `String(undefined)` at the Collateral table's
  // `composition` accessor is the live example. `Number("undefined")` is NaN,
  // and NaN was rendered verbatim: the user saw the literal text "NaN%" in a
  // margin column, and the bar was handed `width: NaN%`, which is invalid CSS
  // and so silently mis-sized.
  //
  // An unknown number is reported as unknown. The marker matches
  // BalanceMarginUtilization, which already renders "---" for the same reason.
  const isKnown = Number.isFinite(percentage);
  return (
    <FillMeterWrapper textColor={textColor} layoutReversed={layoutReversed}>
      <FillBar
        fillColor={barColor}
        percent={isKnown ? percentage : undefined}
        style={{
          marginRight: layoutReversed ? 0 : SPACING.two,
          marginLeft: layoutReversed && showText ? SPACING.two : 0,
          ...barStyle,
        }}
      />
      {showText ? (
        <FillPercentage>
          {isKnown ? `${percentage.toFixed(decimals ?? 1)}%` : UNKNOWN_VALUE}
        </FillPercentage>
      ) : null}
    </FillMeterWrapper>
  );
}

export default FillMeter;
